import { Component, ElementRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppMenu } from './app.menu';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [AppMenu, RouterModule],
    template: `<div class="layout-sidebar">
        <a routerLink="/dashboard" class="layout-sidebar-brand">
            <span class="layout-sidebar-brand-logo">
                <img src="./images/isologo.png" alt="Mi Jornada" />
            </span>
            <span class="layout-sidebar-brand-text">
                <span class="layout-sidebar-brand-name">Mi Jornada</span>
                <span class="layout-sidebar-brand-tagline">Control de Asistencia</span>
            </span>
        </a>
        <app-menu></app-menu>
    </div>`
})
export class AppSidebar {
    constructor(public el: ElementRef) {}
}
